import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		defaultMessage: 'Add gadget',
		id: 'dashboard-edit.header-editable.add-gadget-button.title',
		description: 'Describes the specific role of this modal.',
	},
	linkTitle: {
		defaultMessage: 'add a new gadget',
		id: 'dashboard-edit.header-editable.add-gadget-button.link-title',
		description: 'Describes the specific role of this modal.',
	},
	errorFlagTitle: {
		defaultMessage: 'Error',
		id: 'dashboard-edit.header-editable.add-gadget-button.error-flag-title',
		description: 'Show there is an error',
	},
	errorFlagDescription: {
		defaultMessage: 'We cannot add any new gadgets at the moment',
		id: 'dashboard-edit.header-editable.add-gadget-button.error-flag-description',
		description: 'Describes the error when user cannot open the add gadget modal',
	},
	errorFlagAction: {
		defaultMessage: 'Refresh',
		id: 'dashboard-edit.header-editable.add-gadget-button.error-flag-action',
		description: 'Describes the error when user cannot open the add gadget modal',
	},
});
